<template>
  <div class="space-y-6">
    <h2>{{ videoId ? t('editVideo') : t('createVideo') }}</h2>
    <VideoForm :initial-video="video" @saved="$emit('saved')" @cancel="$emit('cancel')" />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import VideoForm from './VideoForm.vue';
import { useVideo } from '@/queries/use-videos';

const { t } = useI18n();

defineEmits<{
  (e: 'saved'): void;
  (e: 'cancel'): void;
}>();

const props = defineProps<{
  videoId: string | null;
}>();

const { data: video } = useVideo(props.videoId);
</script>

<i18n lang="json">
{
  "en": {
    "createVideo": "Create video",
    "editVideo": "Edit video"
  },
  "de": {
    "createVideo": "Video erstellen",
    "editVideo": "Video bearbeiten"
  },
  "es": {
    "createVideo": "Crear vídeo",
    "editVideo": "Editar vídeo"
  }
}
</i18n>
